<mat-tree [dataSource]="treeDataSource" [treeControl]="treeControl">    
    <!-- <div class="nsw-form__group"> -->
        <mat-tree-node *matTreeNodeDef="let node; " matTreeNodeToggle matTreeNodePadding>
            
            <input class="nsw-form__checkbox-input" type="checkbox" [name]="node.label" [id]="node.label"
                (change)="treeLeafItemSelectionToggle(node)"
                [checked]="checklistSelection.isSelected(node) ? '' : null">
            <label class="nsw-form__checkbox-label" [for]="node.label">{{node.label}}</label>            
        </mat-tree-node>                        
    
        <mat-tree-node *matTreeNodeDef="let node; when : hasChild" matTreeNodePadding>
            <button mat-icon-button matTreeNodeToggle [attr.aria-label]="'Toggle ' + node.label">
                <mat-icon class="mat-icon-rtl-mirror" [svgIcon]="treeControl.isExpanded(node) ? 'chevronDown' : 'chevronRight'">                    
                </mat-icon>
            </button>
            <input class="nsw-form__checkbox-input" type="checkbox" [name]="node.label" [id]="node.label"
                (change)="treeItemSelectionToggle(node)"
                [indeterminate]="descendantsPartiallySelected(node)"
                [checked]="descendantsAllSelected(node)">
            <label class="nsw-form__checkbox-label" [for]="node.label">{{node.label}}</label>            
        </mat-tree-node>
    <!-- </div>     -->
</mat-tree>
